import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Chip } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBoxOutlined } from "@material-ui/icons";
import { ReactNode } from "react";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
  },
  tag: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },
  option: {
    padding: 0,
    transitionDuration: "50",
    backgroundColor: "unset",
    "&[aria-selected=true]": {
      backgroundColor: "unset",
    },
  },
  paper: {
    padding: 2,
    marginTop: -3,
    marginLeft: 2,
    boxShadow: "0px 6px 12px -4px #222",
    border: `2px solid ${theme.palette.primary.main}`,
    borderTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  groupLabel: {
    color: theme.palette.primary.main,
    lineHeight: "18px",
    paddingTop: theme.spacing(1.2),
  },
}));

export type AutoCompleteOptions = {
  key: string;
  label: string;
  labelPrefix?: ReactNode | string;
  labelSuffix?: ReactNode | string;
};

type Props = {
  options: AutoCompleteOptions[];
  selection: AutoCompleteOptions[];
  selectionHandler: (selection: AutoCompleteOptions[]) => void;
  label?: string;
  placeholder?: string;
  helperText?: string;
};

export function AutocompleteChips({
  options,
  selection,
  selectionHandler,
  label,
  placeholder,
  helperText,
}: Props) {
  const classes = useStyles();
  return (
    <Autocomplete
      fullWidth
      multiple
      disableCloseOnSelect
      size="small"
      classes={classes}
      options={options}
      value={selection}
      onChange={(_, selected) => {
        selectionHandler(selected);
      }}
      renderOption={(option, { selected }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              color: "#333",
              alignItems: "center",
              padding: 8,
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {selected ? (
                <CheckBoxOutlined style={{ marginRight: 8 }} />
              ) : (
                <CheckBoxOutlineBlank style={{ marginRight: 8 }} />
              )}
              {option.label}
            </div>
            <div>{option.labelSuffix}</div>
          </div>
        );
      }}
      getOptionLabel={option => option.label}
      getOptionSelected={(option, value) => {
        return option.key == value.key;
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          label={label}
          placeholder={placeholder}
          helperText={helperText}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip key={index} size="small" label={option.label} {...getTagProps({ index })} />
        ))
      }
    />
  );
}
